'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _stepSaga = require('./stepSaga');

var _executeActionSaga = require('./executeActionSaga');

var _workflow = require('../../constants/actions/workflow');

var _setReturnSaga = require('./setReturnSaga');

var _getWorkflowConfogurationSaga = require('./getWorkflowConfogurationSaga');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(watchGetWorkflowConfiguration),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchStep),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(watchSetReturn),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchExecuteAction),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(root);

function watchGetWorkflowConfiguration() {
    return regeneratorRuntime.wrap(function watchGetWorkflowConfiguration$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.takeLatest)(_workflow.GET_WORKFLOW_CONFIGURATION, _getWorkflowConfogurationSaga.getWorkflowConfigurationSaga);

                case 2:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchStep() {
    return regeneratorRuntime.wrap(function watchStep$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(_workflow.STEP, _stepSaga.stepSaga);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function watchSetReturn() {
    return regeneratorRuntime.wrap(function watchSetReturn$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.takeLatest)(_workflow.SET_RETURN, _setReturnSaga.setReturnSaga);

                case 2:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function watchExecuteAction() {
    return regeneratorRuntime.wrap(function watchExecuteAction$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(_workflow.EXECUTE_ACTION, _executeActionSaga.executeActionSaga);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function root() {
    return regeneratorRuntime.wrap(function root$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return (0, _effects.all)([(0, _effects.fork)(watchStep), (0, _effects.fork)(watchSetReturn), (0, _effects.fork)(watchExecuteAction), (0, _effects.fork)(watchGetWorkflowConfiguration)]);

                case 2:
                    return _context5.abrupt('return', _context5.sent);

                case 3:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

exports.default = root;